import { render, staticRenderFns } from "./ServiceLaw.vue?vue&type=template&id=6cb21e75&scoped=true"
import script from "./ServiceLaw.vue?vue&type=script&lang=js"
export * from "./ServiceLaw.vue?vue&type=script&lang=js"
import style0 from "./ServiceLaw.vue?vue&type=style&index=0&id=6cb21e75&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb21e75",
  null
  
)

export default component.exports